import React, { ReactElement, useState, useMemo, useCallback } from 'react';
import { size, slice } from 'lodash';
import { Button, ResponsivenessGrid } from '../toolkit';

type ShowMoreItemsProps = {
    range: number,
    buttonTitle: string,
    items: any[],
    width?: number,
    breakpoint?: string
}

export function ShowMoreItems({range, buttonTitle, items, width, breakpoint}: ShowMoreItemsProps): ReactElement {
    const [actualRange, setActualRange] = useState<number>(range);
    
    const updateRange = useCallback(() => {
        let newRange = actualRange + range;
        setActualRange(newRange);
    }, [actualRange, range]);

    const itemsToShow = useMemo(() => {
        return slice(items, 0, actualRange);
    }, [actualRange, items]);

    const button = useMemo(() => {
        const buttonItems = actualRange < size(items) ? {
            title: buttonTitle,
            icon: "add"
        } : null;
        
        if (buttonItems)
            return <Button id="show-more" onButtonClicked={updateRange}>
                <i className="rese-button-icon material-icons mdc-button__icon" aria-hidden="true">{buttonItems.icon}</i>
                <span>{buttonItems.title}</span>
            </Button>;
        return null;
    }, [actualRange, items, buttonTitle, updateRange]);

    return <div>
        <div className="rese-search-result">
            <ResponsivenessGrid 
                width={width}
                currentBreakpoint={breakpoint}
                items={itemsToShow}
                isSquare
            />
            <br />
            {button}
        </div>
    </div>;
}
